/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Auth_Email_LabelInputs */



/**
* | output |
* | --- |
* | "Email address" |
*
* @param {Work_Order_Publish_Auth_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_auth_email_label = /** @type {((inputs?: Work_Order_Publish_Auth_Email_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Auth_Email_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Adresse e-mail")
	if (locale === "de") return /** @type {LocalizedString} */ ("E-Mail-Adresse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Indirizzo e-mail")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Адрес электронной почты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dirección de correo electrónico")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("电子邮件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("電子メールアドレス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेल पता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Endereço de email")
	return /** @type {LocalizedString} */ ("Email address")
});